import {useEffect, useState} from 'react';
import {Ticket} from '../types';
import {useWorkspace} from '../workspace/WorkspaceContext';
import {useReplySubmission} from './useReplySubmission';
import {useTicketOperations} from './useTicketOperations';

export function useTicketReply(ticket: Ticket) {
  const {update, generating} = useWorkspace();
  const serverDraft = ticket.draft;
  const [draft, setDraft] = useState(serverDraft);
  const [tone, setTone] = useState('Friendly');
  const [deleteOpen, setDeleteOpen] = useState(false);
  const dirty = draft !== serverDraft;
  const generation = generating[ticket.id];
  // Only a server draft change resets the editor; triage and feedback must not.
  useEffect(() => { setDraft(serverDraft); }, [serverDraft, setDraft]);
  const submission = useReplySubmission({ticket, draft, dirty, setDraft, update});
  const operations = useTicketOperations({ticket, dirty, tone, save: submission.save});
  return {draft, setDraft, tone, setTone, dirty, generation, busy: Boolean(generation), deleteOpen, setDeleteOpen, ...submission, ...operations};
}
export type TicketReplyController = ReturnType<typeof useTicketReply>;